import type { ReactNode } from "react";

import { ControlledSelect } from "@/components/Select/ControlledSelect";

import {
  CFormItemBase,
  type CFormItemProps,
  buildCFormItem,
} from "../CFormItem";

type Option = {
  value: string;
  label: string;
};

type Props = CFormItemProps & {
  value?: string;
  onChange: (value: string) => void;
  inputClassName?: string;
  fetchOptions?: (text?: string) => Promise<Option[]>;
  /** 初期表示の値 */
  displayValue?: string;
  readComponent?: ReactNode;
  hideSearch?: boolean;
  inputWidth?: number | string;
};

/**
 * Card-based Form / SelectItem
 */
export const CFormSelectItem = buildCFormItem((props: Props) => {
  return (
    <CFormItemBase
      {...props}
      readComponent={props.readComponent ?? props.displayValue}
      writeComponent={
        <ControlledSelect
          id={props.id}
          value={props.value}
          onChange={(option) => props.onChange(option?.value ?? "")}
          fetchOptions={props.fetchOptions}
          hideSearch={props.hideSearch}
          allowEmpty={!props.required}
          width={props.inputWidth}
          disabled={props.readonly}
        />
      }
    />
  );
});
